define('app/sf/trim/sf-trim',[],function () {
	return sfTrim;
	function sfTrim(value) {
		return (value + "").trim();
	}
});
